import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-add-award',

  templateUrl: './add-award.component.html',
  styleUrl: './add-award.component.css'
})
export class AddAwardComponent implements OnInit {
awardForm !: FormGroup;
  selectedDomain = 'Residential'; // default
   domainOptions:any[] = [];
  //  [
  //   'Residential', 'Commercial', 'Educational', 'Water',
  //   'Power', 'Gas', 'Telecom', 'Road', 'Consultancy'
  // ];
  optionsMap: { [key: string]: any[] } = {
    domainOptionsDrp: this.domainOptions
  };

  domainFields: { [key: string]: any[] } = {
   Residential: [
    { key: 'housingUnitsAwarded', label: 'Housing Units Awarded', type: 'number', required: true, value: 100 },
    { key: 'amenitiesScope', label: 'Amenities Scope', type: 'text', required: false, value: 'Clubhouse, Park' }
  ],
  Commercial: [
    { key: 'retailSpaceScope', label: 'Retail Space Scope', type: 'text', required: true, value: '50000 sq ft' },
    { key: 'parkingInfrastructure', label: 'Parking Infrastructure', type: 'number', required: true, value: 200 }
  ],
  Educational: [
    { key: 'classroomCount', label: 'Classroom Count', type: 'number', required: true, value: 50 },
    { key: 'labSetupScope', label: 'Lab Setup Scope', type: 'text', required: false, value: 'Physics, Chemistry Labs' }
  ],
  Water: [
    { key: 'treatmentPlantCapacity', label: 'Treatment Plant Capacity', type: 'text', required: true, value: '1 million liters/day' },
    { key: 'pipelineNetworkScope', label: 'Pipeline Network Scope', type: 'text', required: true, value: '20 km' }
  ],
  Power: [
    { key: 'substationCapacity', label: 'Substation Capacity', type: 'text', required: true, value: '50 MW' },
    { key: 'transformerCount', label: 'Transformer Count', type: 'number', required: true, value: 3 }
  ],
  Gas: [
    { key: 'pipelineLengthAwarded', label: 'Pipeline Length Awarded', type: 'text', required: true, value: '25 km' },
    { key: 'safetySystemScope', label: 'Safety System Scope', type: 'text', required: false, value: 'Leak detection, valves' }
  ],
  Telecom: [
    { key: 'towerCount', label: 'Tower Count', type: 'number', required: true, value: 5 },
    { key: 'fiberOpticLength', label: 'Fiber Optic Length', type: 'text', required: true, value: '100 km' }
  ],
  Road: [
    { key: 'roadLengthAwarded', label: 'Road Length Awarded', type: 'text', required: true, value: '15 km' },
    { key: 'laneCount', label: 'Lane Count', type: 'number', required: true, value: 4 }
  ],
  Consultancy: [
    { key: 'advisoryScope', label: 'Advisory Scope', type: 'text', required: true, value: 'Feasibility + Design' },
    { key: 'durationAwarded', label: 'Duration Awarded', type: 'duration', required: true, value: '6 months' }
  ]
  };


  commonFields = [
  { key: 'awardId', label: 'Award ID', type: 'text', required: true, value: 'AWARD-2024-003' },
  { key: 'projectName', label: 'Project Name', type: 'text', required: true, value: 'SigmaTConflux Infrastructure Project' },
  { key: 'awardDate', label: 'Award Date', type: 'date', required: true, value: '2024-02-20' },
  { key: 'awardedTo', label: 'Awarded To', type: 'text', required: true, value: 'InfraBuild Ltd' },
  { key: 'contractValue', label: 'Contract Value', type: 'currency', required: true, value: 97500000 },
  { key: 'scopeOfWork', label: 'Scope of Work', type: 'text', required: true, value: 'Civil + MEP works' },
  { key: 'contractDuration', label: 'Contract Duration', type: 'duration', required: true, value: '12 months' },
  { key: 'performanceGuarantee', label: 'Performance Guarantee', type: 'currency', required: true, value: 5000000 },
  { key: 'awardDocumentRef', label: 'Award Document Ref', type: 'text', required: true, value: 'AWD-2024-Infra' },
  { key: 'awardStatus', label: 'Award Status', type: 'text', required: true, value: 'Finalized' },
  { key: 'domain', label: 'Domain', type: 'select', optionKey: 'domainOptionsDrp', required: true, value: 'Residential', onChange: (value: string) => this.onDomainChange(value) }
];

  pickerMap: { [key: string]: MatDatepicker<any> } = {};
  constructor(private fb: FormBuilder, private readonly apiService: ApiService, private readonly toastrMsgService: ToastrMsgService) { }

 ngOnInit(): void {
  this.awardForm  = this.fb.group({});
  this.commonFields.forEach(field => {
    const validators = field.required ? [Validators.required] : [];
    this.awardForm .addControl(field.key, this.fb.control(field.value || '', validators));
  });
  this.onDomainChange(this.selectedDomain);
}



  onSubmit() {
    if (this.awardForm .valid) {
      console.log(this.awardForm .value);
    }
  }
  onReset(): void {
    this.awardForm .reset();
  }
onDomainChange(domain: string) {
    this.selectedDomain = domain;
    Object.keys(this.awardForm .controls).forEach(key => {
      if (key !== 'domain' && this.domainFields[domain]?.find(field => field.key === key) === undefined &&
        Object.values(this.domainFields).flat().some(field => field.key === key)) {
        this.awardForm .removeControl(key);
      }
    });
    this.domainFields[domain].forEach(field => {
      this.awardForm .addControl(field.key, this.fb.control(field.value));
    });

  }

}
